var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.99998 3.83337L8.82498 5.00837L13.475 9.66671H3.33331V11.3334H13.475L8.82498 15.9917L9.99998 17.1667L16.6666 10.5L9.99998 3.83337Z"}));
}

ArrowRight.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"currentColor"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
